import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/AuthContext';
import AuthPage    from './pages/AuthPage';
import Dashboard   from './pages/Dashboard';
import AnalysePage from './pages/AnalysePage';

function RequireAuth({ children }) {
  const { session, loading } = useAuth();
  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'#040c18' }}>
      <div style={{ width:32, height:32, border:'3px solid #1e2d4a', borderTop:'3px solid #3b82f6', borderRadius:'50%', animation:'spin 0.8s linear infinite' }}/>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
  return session ? children : <Navigate to="/" replace/>;
}

function AppRoutes() {
  const { session, loading } = useAuth();
  if (loading) return null;
  return (
    <Routes>
      <Route path="/" element={session ? <Navigate to="/dashboard" replace/> : <AuthPage/>}/>
      <Route path="/dashboard" element={<RequireAuth><Dashboard/></RequireAuth>}/>
      <Route path="/analyse"   element={<RequireAuth><AnalysePage/></RequireAuth>}/>
      <Route path="*"          element={<Navigate to="/" replace/>}/>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes/>
      </AuthProvider>
    </BrowserRouter>
  );
}
